import { render, staticRenderFns } from "./MultiSelectPriceSet.vue?vue&type=template&id=b9c0a31e&"
import script from "./MultiSelectPriceSet.vue?vue&type=script&lang=js&"
export * from "./MultiSelectPriceSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports